// React Basic and Bootstrap
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Alert } from 'reactstrap';

// Import images
import coworking_space from '../../images/coworking_space.jpg';
import roundWhite from '../../images/shapes/round-white.png';
import guideMap from '../../images/startupknox/Startupknox_Icons_map.png'
// RBCarousel Declare
import RBCarousel from "react-bootstrap-carousel";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import './carousel.css';

// Modal Video
import ModalVideo from 'react-modal-video'
import '../../../node_modules/react-modal-video/scss/modal-video.scss';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// import generic components
import Colors from "../../Colors";
import NewsLetter from "./NewsLetter";
import TheTeam from "./TheTeam";
import pdfIcon from "../../images/icon/pdf_icon.png";
import Modal_Email_Submit from "../../components/Modal/Modal_Email_Submit";
import {API} from "aws-amplify";
import skLogo from "../../images/startupknox/logos/STK_logo_simple.png";
import WhatIsSTK from "../../components/Shared/WhatIsSTK";
import SponsorshipBanner from "../../components/Shared/SponsorshipBanner";

class Index extends Component {

    constructor(props) {
        super(props);
        this.state = {
            autoplay: true,
            isOpen: false,
            startDate: new Date(),
            endDate: new Date(),
            Contactvisible : false,
            status: 'inactive'
        }
        this.openModal = this.openModal.bind(this);
        this.handleStart = this.handleStart.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({Contactvisible : true});
    }


    handleStart = date => {
        this.setState({
            startDate: date
        });
    };

    handleEnd = date => {
        this.setState({
            endDate: date
        });
    };

    openModal() {
        this.setState({ isOpen: true })
    }

    onSelect = (active, direction) => {
        console.log(`active=${active} && direction=${direction}`);
    };
    visiableOnSelect = active => {
        // console.log(`visiable onSelect active=${active}`);
    };
    slideNext = () => {
        this.slider.slideNext();
    };
    slidePrev = () => {
        this.slider.slidePrev();
    };
    goToSlide = () => {
        this.slider.goToSlide(4);
    };
    autoplay = () => {
        this.setState({ autoplay: !this.state.autoplay });
    };
    _changeIcon = () => {
        let { leftIcon, rightIcon } = this.state;
        leftIcon = leftIcon ? undefined : <span className="fa fa-glass" />;
        rightIcon = rightIcon ? undefined : <span className="fa fa-music" />;
        this.setState({ leftIcon, rightIcon });
    };

    componentDidMount() {
        document.body.classList = "";
        document.body.style.overflowY = "auto"
        document.body.style.overflowX = 'hidden'

        document.getElementById('topnav').classList.add('bg-white');
        window.addEventListener("scroll", this.scrollNavigation, true);
        const anchor = document.querySelector(`#top`)
        anchor.scrollIntoView({ behavior: 'auto', block: 'start' })
    }

     // Make sure to remove the DOM listener when the component is unmounted.
     componentWillUnmount() {
        window.removeEventListener("scroll",this.scrollNavigation);
     }

    scrollNavigation = () => {
        var doc = document.documentElement;
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (top > 80) {
            document.getElementById('topnav').classList.add('nav-sticky');
        }
        else {
            document.getElementById('topnav').classList.remove('nav-sticky');
        }
    }

    submitEmail = (formData) => {
        this.setState({...this.state, status: 'submitting-email'})
        let apiName = 'startup-knox'; // replace this with your api name.
        let path = 'newsletterSubscribe'; //replace this with the path you have configured on your API
        let myInit = {
            body: {
                email: formData.email,
                firstName: formData.firstName,
                lastName: formData.lastName
            }, // replace this with attributes you need
            headers: {
                // 'Content-Type': 'application/json',
                // 'Accept': 'application/json',
                // 'Access-Control-Allow-Origin': '*',
                // 'Access-Control-Allow-Credentials': true
            } // OPTIONAL
        }

        API.post(apiName, path, myInit).then(response => {
            console.log('post succeeded!', response)

            this.setState({...this.state, status: 'inactive'})
            document.body.style.overflowY = "auto"
            window.open('https://startup-knox-public.s3.amazonaws.com/StartupKnox_2020EcosystemsGuide_Download.pdf', '_blank');
        }).catch(error => {
            console.log('post failed!', error)

            this.setState({...this.state, status: 'inactive'})
            document.body.style.overflowY = "auto"
            window.open('https://startup-knox-public.s3.amazonaws.com/StartupKnox_2020EcosystemsGuide_Download.pdf', '_blank');
        });
    }
    cancel = () => {
        document.body.style.overflowY = "auto"
        this.setState({...this.state, status: 'inactive'})
    }
    renderModal = (status) => {
        if(status === 'inactive') return null
        else{
            return <div style={{height: '100vh', width: '100vw', marginTop: 75, position: 'fixed', zIndex: 100000, backgroundColor: Colors.darkBlue(0.3), display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Modal_Email_Submit isVisible onPress={this.submitEmail} onCancel={this.cancel} isLoading={this.state.status === 'submitting-email'}/>
            </div>
        }
    }

    render() {

        return (
            <React.Fragment>
                {this.renderModal(this.state.status)}
                {/* Hero Start */}
                <section className="main-slider" id={'top'}>
                    <ul className="slides">
                        {/*<RBCarousel*/}
                        {/*    version={4}*/}
                        {/*    autoplay={this.state.autoplay}*/}
                        {/*    pauseOnVisibility={true}*/}
                        {/*    onSelect={this.visiableOnSelect}*/}
                        {/*    slideshowSpeed={3000}*/}
                        {/*>*/}
                            <div className="item">
                                <li className="bg-slider bg-animation-left" style={{ backgroundImage: `url(${coworking_space})` }} >
                                    <div className="home-center">
                                        <div className="home-desc-center">
                                            <div className="container">
                                                <Row className="align-items-center">
                                                    <Col lg={7} md={6}>
                                                        <div className="title-heading position-relative" style={{ zIndex: 1 }}>
                                                            <div className="icon" style={{display: 'flex', justifyContent: 'center', marginTop: -25, marginBottom: 20}}>
                                                                <img src={skLogo} style={{maxHeight: 175, maxWidth: 175}}/>
                                                            </div>
                                                            <h1 className="display-4 mb-3" style={{color: Colors.darkBlue()}}>Growing The Knoxville Startup Community </h1>
                                                            <p className="para-desc" style={{fontStyle: 'italic', fontWeight: 'bold', color: Colors.darkBlue()}}>“I believe it is our time in East Tennessee. It is a season when East Tennessee is becoming an entrepreneurial epicenter. I promise the atmosphere in Knoxville has never been as hot to crush paradigms, disrupt the status quo, and launch new business as it is today. The foundation is set; what will we do with it?”</p>
                                                            <div style={{flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginRight: 40}}>
                                                                <span style={{width: '50%', textAlign: 'center', fontWeight: 'bold', color: Colors.persimmon()}}>– Bill Malkes, co-founder and former CEO of GRIDSMART Technologies, Inc & CEO of NellOne.</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </div>
                    </ul>
                </section>
                {/*<SponsorshipBanner/>*/}
                <WhatIsSTK/>
                <section className="bg-half-260" style={{ paddingTop: 30, background: `linear-gradient(347deg, rgba(243,112,81,1) 0%, rgba(243,112,81,1) 7%, rgba(249,229,219,1) 100%)` }}>
                    <div className="home-center">
                        <div className="home-desc-center">
                            <div className="container">
                                <Row>
                                    <Col>
                                        <div className="title-heading text-center mt-4">
                                            <h1 className="display-3 mb-3" style={{color: Colors.darkBlue()}}>The Ecosystem Guide</h1>
                                            <p className="para-desc mx-auto" style={{color: Colors.darkBlue()}}>
                                                We’re excited to bring you the first-of-its-kind 2020 Ecosystem Guide,
                                                a comprehensive guide to the local startup ecosystem in the greater Knoxville area.
                                            </p>
                                            <p className="para-desc mx-auto" style={{color: Colors.darkBlue()}}>
                                                We’ve organized resources into 7 sections: News, Events, Organizations,
                                                Programs, Places, Funding, and Education. Each resource has a name, a brief description, and
                                                a clickable website address.
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <Row>
                                <Col>
                                    <div style={{width: '100%', display:'flex', justifyContent:'center'}}>
                                        <div style={{backgroundImage: `url(${guideMap}`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', width: '95%', height: 350 }}/>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="title-heading text-center mt-4">
                                        <p className="para-desc mx-auto" style={{color: Colors.darkBlue()}}>
                                            Whether you’ve lived here your entire life, or you recently moved to the area,
                                            or you’re visiting, we want you to know that our community is friendly,
                                            inclusive, and ready to help you grow both personally and professionally.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <div className="text-center mt-4 pt-2">
                                <Link to="/guide" className="btn btn-light">Explore The Guide</Link>
                                <br/>
                                <a className="btn btn-primary mt-2" style={{flexWrap: 'wrap'}}
                                   onClick={
                                       () => {
                                           document.body.style.overflowY = "hidden"
                                           this.setState({...this.state, status: 'requesting-email'})
                                       }}>
                                    <span className={'text'} style={{color: Colors.pale()}}>
                                      Download
                                      <div className="icon">
                                        <img src={pdfIcon} style={{height: 45, width: 45}}/>
                                      </div>
                                    </span>
                                </a>
                            </div>
                            <div className="container-fluid">
                                <Row>
                                    <div className="home-shape-bottom">
                                        <img src={roundWhite} alt="" className="img-fluid mx-auto d-block" />
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </div>
                </section>

               <NewsLetter/>
               <TheTeam/>
            </React.Fragment>
        );
    }
}

export default Index;
